import { render, staticRenderFns } from "./ResultTopic.vue?vue&type=template&id=e664bbb2&scoped=true&"
import script from "./ResultTopic.vue?vue&type=script&lang=js&"
export * from "./ResultTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e664bbb2",
  null
  
)

export default component.exports